export const STATUS_ID = 'materialStatus';
